const types = ["pending", "completed", "error", "syncing"];
const MwsSynchronizationStatuses = types.map((value) => ({
    value,
    text: value.toUpperCase(),
}));

export default MwsSynchronizationStatuses;
